/* src/app/features/contratacao/limite-exposicao/pesquisa/limite-exposicao-pesquisa.component.scss */
.moeda {
  text-align: right;
}
.titulo-moeda {
  text-align: right;
}
.letra-miuda {
  font-size: 12px;
  font-style: italic;
}
.texto-destaque {
  font-weight: bolder;
}
.fundo-destaque {
  background-color: lightyellow;
}
.disabled-ng-select {
  opacity: 0.5;
  pointer-events: none;
}
/*# sourceMappingURL=limite-exposicao-pesquisa.component.css.map */
